// 依赖：需确保页面已加载 jQuery（如 <script src="https://code.jquery.com/jquery-3.6.4.min.js"></script>）

// ==============================================================
// 1. 购物车按钮事件处理核心功能
// ==============================================================
function handleAddToCartClick(e) {
  e.preventDefault();
  let button = $(this);
  
  // 保存原始HTML（包含SVG等标记）
  const originalHTML = button.data('original-html') || button.html();
  if (!button.data('original-html')) {
    button.data('original-html', originalHTML);
  }
  
  // 按钮状态切换（加载中）
  button.html('<span class="spinner">Adding....</span>')
    .attr('disabled', true)
    .addClass('btn-loading');
  
  // 发送添加到购物车请求（Shopify 标准接口）
  const variantID = button.data('product-variant');
  const quantity = 1;
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity, id: variantID },
    dataType: 'json',
    success: function(response) {
      // 更新购物车数量和抽屉
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cartData => {
          $('.hdt-site-nav_cart .hdt-count-box').text(cartData.item_count);
          // 延迟刷新购物车抽屉（确保数据同步）
          setTimeout(() => {
            $("hdt-cart-drawer").load(location.href + " hdt-cart-drawer");
          }, 500);
        });
      
      // 成功状态提示
      button.html('Added!').removeClass('btn-loading');
      
      // 延迟恢复原始按钮状态
      setTimeout(() => {
        button.html(button.data('original-html'))
          .removeAttr('disabled')
          .removeClass('btn-loading');
      }, 2000);
    },
    error: function() {
      // 失败状态提示（如售罄）
      button.html('Error: Sold Out').removeClass('btn-loading');
      
      setTimeout(() => {
        button.html(button.data('original-html'))
          .removeAttr('disabled')
          .removeClass('btn-loading');
      }, 2000);
    }
  });
}

// 购物车事件初始化与DOM变化监听
function initAddToCart() {
  // 页面加载时绑定事件
  $(document).on('click', '.sv-collection-add-to-cart-btn', handleAddToCartClick);
  
  // 监听DOM变化（处理动态加载的按钮）
  function observeDOMChanges() {
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          bindButtonsOnDOMChange();
        }
      });
    });
    if (document.body) observer.observe(document.body, config);
  }
  
  // DOM变化时绑定新按钮
  function bindButtonsOnDOMChange() {
    setTimeout(() => {
      const newButtons = $('.sv-collection-add-to-cart-btn:not(.btn-bound)');
      if (newButtons.length > 0) {
        newButtons.addClass('btn-bound').on('click', handleAddToCartClick);
      }
    }, 300);
  }
  
  // 启动DOM监听
  observeDOMChanges();
  
  // 暴露手动绑定方法到全局
  window.forceBindAddToCart = function() {
    $(document).off('click', '.sv-collection-add-to-cart-btn');
    $(document).on('click', '.sv-collection-add-to-cart-btn', handleAddToCartClick);
  };
}

// ==============================================================
// 2. 型号/类型筛选功能（核心：型号切换移除color-index）
// ==============================================================
(function($) {
  // 机型 handle 的统一正则（含 16e / 17e / air）
  const MODEL_REGEX = /collections\/(iphone-(?:\d{1,2}|16e|17e|air)(?:-pro)?(?:-plus)?(?:-max)?-cases)/;

  function initCollectionFilter() {
    const currentUrl = window.location.href;

    // Initialize model filter
    handleModelFilter(currentUrl);
    // Initialize type filter
    handleTypeFilter(currentUrl);

    // Model select change event
    $('#sv_filter_size').on('change', function() {
      const selectedModel = $(this).val();
      if (selectedModel) updateUrlWithModel(selectedModel);
    });

    // Type click event
    $('.sv_coll_filter_type a').on('click', function(e) {
      e.preventDefault();
      const caseType = $(this).attr('data-case-type');

      $('.sv_current_type').removeClass('sv_current_type');
      $(this).closest('li').addClass('sv_current_type');

      updateUrlWithCaseType(caseType);
    });
  }

  function handleModelFilter(url) {
    const match = url.match(MODEL_REGEX);
    if (match && match[1]) {
      $(`#sv_filter_size option[value="${match[1]}"]`).prop('selected', true);
    }
  }

  // 改为根据路径上的 tag 高亮当前类型： /collections/{机型}/{tag}
  function handleTypeFilter(url) {
    const urlObj = new URL(url, window.location.origin);
    const match = urlObj.pathname.match(/\/collections\/[^\/]+\/([^\/?#]+)/);

    $('.sv_current_type').removeClass('sv_current_type');

    if (match && match[1]) {
      const currentTag = decodeURIComponent(match[1]).toLowerCase();
      $('.sv_coll_filter_type a').each(function() {
        if (($(this).attr('data-case-type') || '').toLowerCase() === currentTag) {
          $(this).closest('li').addClass('sv_current_type');
        }
      });
    } else {
      // 路径上没有 tag，说明是 View All
      $('.sv_coll_filter_type li:first-child').addClass('sv_current_type');
    }
  }

  function updateUrlWithModel(model) {
    const urlObj = new URL(window.location.href, window.location.origin);

    urlObj.searchParams.delete('color-index');
    urlObj.searchParams.delete('page');
    urlObj.searchParams.delete('filter.v.option.case type'); // 清掉旧的 query 筛选（如有）
    const cleanedUrl = urlObj.toString();

    if (window.resetColorFilterState) window.resetColorFilterState();

    // 只替换 collection handle，路径上的 tag（如 /velvet）会被保留
    if (cleanedUrl.includes('all-iphone-cases')) {
      window.location.href = cleanedUrl.replace('all-iphone-cases', model);
      return;
    }

    if (cleanedUrl.match(MODEL_REGEX)) {
      window.location.href = cleanedUrl.replace(MODEL_REGEX, `collections/${model}`);
    } else {
      const [baseUrl, queryString] = cleanedUrl.split('?');
      let newBaseUrl;

      if (baseUrl.endsWith('/collections/')) {
        newBaseUrl = `${baseUrl}${model}`;
      } else if (baseUrl.includes('/collections/')) {
        newBaseUrl = baseUrl.replace('/collections/', `/collections/${model}/`);
      } else {
        newBaseUrl = `${baseUrl}/collections/${model}`;
      }

      window.location.href = queryString
        ? `${newBaseUrl}?${queryString}`
        : newBaseUrl;
    }
  }

  // 改为用 tag 路径： /collections/{机型}/{tag}
  function updateUrlWithCaseType(caseType) {
    const urlObj = new URL(window.location.href, window.location.origin);

    urlObj.searchParams.delete('page');
    urlObj.searchParams.delete('filter.v.option.case type'); // 清掉旧的 query 筛选

    // 取出 collection 段（去掉已有的 tag），例如 /collections/iphone-17-cases
    const match = urlObj.pathname.match(/(\/collections\/[^\/]+)/);
    if (match) {
      const collectionPath = match[1];
      urlObj.pathname = (caseType === 'default')
        ? collectionPath
        : `${collectionPath}/${caseType}`;
    }

    window.location.href = urlObj.toString();
  }

  $(document).ready(function() {
    initCollectionFilter();
  });
})(jQuery);

// ==============================================================
// 3. 颜色筛选功能（含排序后筛选保持功能）
// ==============================================================
$(document).ready(function() {
  const CONFIG = {
    // 基础配置（需与HTML结构匹配）
    targetKeywords: ['collection', 'case'],
    filterContainer: '.phone-color-filter',
    productCard: '.hdt-card-product',
    productListContainer: '.hdt-collection-products',
    mainImage: '.hdt-card-product__media--main',
    colorMedia: '.sv-phone-color-media-data [data-sv-phone-color]',
    colorIndexAttr: 'data-color-index',
    filterItem: '.sv_color_filter_item',
    filterLink: 'a',
    paginationList: '.hdt-pagination__list',
    paginationLink: 'a.hdt-pagination__item',
    activeFilterClass: 'selected'
  };

  // 页面合法性校验（仅在手机壳集合页生效）
  function isTargetPage() {
    const currentUrl = window.location.href.toLowerCase();
    return CONFIG.targetKeywords.every(keyword => currentUrl.includes(keyword));
  }
  if (!isTargetPage()) return;

  // 获取当前URL中的color-index参数
  function getCurrentColorIndex() {
    return new URLSearchParams(window.location.search).get('color-index') || '1';
  }

  // Liquid provides the exact current Shopify media URLs, including ?v=.
  // JavaScript only applies those URLs; it never derives a filename or cache key.
  function updateProductImages(colorIndex, $targetCards = null) {
    const $cards = $targetCards || $(CONFIG.productCard);

    $cards.each(function() {
      const $card = $(this);
      const $source = $card.find(`${CONFIG.colorMedia}[data-sv-phone-color="${colorIndex}"]`).first();
      const $image = $card.find(CONFIG.mainImage).first();
      if (!$source.length || !$image.length) return;

      const src = $source.attr('data-src');
      const srcset = $source.attr('data-srcset');
      const alt = $source.attr('data-alt');
      if (!src) return;

      $image.attr('src', src);
      if (srcset) $image.attr('srcset', srcset);
      if (alt) $image.attr('alt', alt);
    });
  }

  // 高亮当前选中的颜色选项
  function highlightActiveColor(colorIndex) {
    $(CONFIG.filterItem).removeClass(CONFIG.activeFilterClass);
    $(`${CONFIG.filterItem} ${CONFIG.filterLink}[${CONFIG.colorIndexAttr}="${colorIndex}"]`)
      .closest(CONFIG.filterItem).addClass(CONFIG.activeFilterClass);
  }

  // 给分页链接添加当前color-index参数
  function appendColorIndexToPagination() {
    const colorIndex = getCurrentColorIndex();
    $(`${CONFIG.paginationList} ${CONFIG.paginationLink}`).each(function() {
      const $link = $(this);
      const href = $link.attr('href');
      if (!href) return;
      const url = new URL(href, window.location.origin);
      url.searchParams.set('color-index', colorIndex);
      $link.attr('href', url.href);
    });
  }

  // 颜色筛选点击事件
  function bindColorFilterClick() {
    $(document).off('click.colorFilter').on('click.colorFilter', 
      `${CONFIG.filterItem} ${CONFIG.filterLink}`, function(e) {
      e.preventDefault();
      const index = $(this).data('color-index');
      if (!index) return;

      // 即时切换 Liquid 输出的真实媒体地址，无需重新载入页面。
      const url = new URL(window.location.href);
      url.searchParams.set('color-index', index);
      url.searchParams.delete('page');
      window.history.pushState({}, '', url.toString());

      updateProductImages(String(index));
      highlightActiveColor(String(index));
      appendColorIndexToPagination();
    });
  }

  // 加载更多商品时，只处理新加入的卡片，不拦截或改写 fetch。
  function observeNewProductCards() {
    const listContainer = document.querySelector(CONFIG.productListContainer);
    if (!listContainer) return;

    const observer = new MutationObserver((mutations) => {
      const newCards = [];
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(CONFIG.productCard)) newCards.push(node);
          newCards.push(...node.querySelectorAll(CONFIG.productCard));
        });
      });

      if (newCards.length) {
        updateProductImages(getCurrentColorIndex(), $(newCards));
      }
    });

    observer.observe(listContainer, { childList: true, subtree: true });
  }

  // 【仅修改此函数】排序后重置颜色筛选（不再保持，改为重置到默认）
  function reapplyColorFilter() {
    const defaultColorIndex = '1'; // 颜色筛选默认值

    // 1. 重置URL：删除color-index参数
    const urlObj = new URL(window.location.href);
    if (urlObj.searchParams.has('color-index')) {
      urlObj.searchParams.delete('color-index');
      window.history.replaceState({}, '', urlObj.toString());
    }

    // 2. 恢复默认 variant 图片和颜色选中态
    updateProductImages(defaultColorIndex);
    highlightActiveColor(defaultColorIndex);

    // 3. 重置分页链接：移除color-index参数
    $(`${CONFIG.paginationList} ${CONFIG.paginationLink}`).each(function() {
      const $link = $(this);
      const href = $link.attr('href');
      if (!href) return;
      const url = new URL(href, window.location.origin);
      url.searchParams.delete('color-index');
      $link.attr('href', url.href);
    });
  }

  // 【仅修改此函数内排序相关逻辑】处理排序功能与颜色筛选的兼容性
  function handleSortingCompatibility() {
    // 监听排序按钮点击事件（不再保存之前的颜色索引，直接重置）
    $(document).on('click', 'hdt-richlist[role="listbox"] button[role="option"]', function() {
      const sortValue = $(this).attr('value');
      if (sortValue) {
        // 延迟执行，确保排序请求已完成且新内容已加载
        setTimeout(() => {
          reapplyColorFilter(); // 调用重置函数，不再传之前的颜色索引
        }, 1200); // 延长延迟确保排序完全完成
      }
    });
    
    // 监听URL中sort_by参数的变化（处理历史记录变化）
    window.addEventListener('popstate', function() {
      if (window.location.search.includes('sort_by=')) {
        setTimeout(() => {
          reapplyColorFilter(); // URL变化时也重置
        }, 1200);
      }
    });
    
    // 【仅修改此部分】排序链接不再保留color-index，而是删除
    function enhanceSortingUrls() {
      // 监听排序下拉框渲染
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            $(mutation.addedNodes).find('button[role="option"]').each(function() {
              const $button = $(this);
              const sortValue = $button.attr('value');
              
              // 为排序按钮添加点击时更新URL的逻辑
              $button.off('click.sortEnhance').on('click.sortEnhance', function(e) {
                // 检查是否是AJAX排序还是页面跳转
                if ($(this).closest('hdt-popover-sorting').length) {
                  e.preventDefault();
                  
                  const urlObj = new URL(window.location.href);
                  // 更新排序参数
                  urlObj.searchParams.set('sort_by', sortValue);
                  // 【关键修改】删除color-index参数，不再保留
                  urlObj.searchParams.delete('color-index');
                  
                  // 执行排序导航
                  window.location.href = urlObj.toString();
                }
              });
            });
          }
        });
      });
      
      // 监听排序下拉框的变化
      if ($('hdt-richlist[role="listbox"]').length) {
        observer.observe($('hdt-richlist[role="listbox"]')[0], {
          childList: true,
          subtree: true
        });
      }
    }
    
    enhanceSortingUrls();
  }

  // 重置颜色筛选状态的方法（供型号切换调用）
  window.resetColorFilterState = function() {
    $(CONFIG.filterItem).removeClass(CONFIG.activeFilterClass); // 取消颜色选中态
  };

  // 初始化颜色筛选
  function initColorFilter() {
    if (!$(`${CONFIG.filterContainer}`).length) return;
    const currentIndex = getCurrentColorIndex();

    updateProductImages(currentIndex);
    highlightActiveColor(currentIndex);
    appendColorIndexToPagination();
    bindColorFilterClick();
    observeNewProductCards();

    // 初始化排序兼容性处理
    handleSortingCompatibility();
  }

  // 启动颜色筛选
  initColorFilter();

  // 监听浏览器历史记录变化（如后退）
  window.addEventListener('popstate', function() {
    const newIndex = getCurrentColorIndex();
    updateProductImages(newIndex);
    highlightActiveColor(newIndex);
  });
});

// ==============================================================
// 4. 辅助功能：禁用图片右键下载
// ==============================================================
// Disable image download
// $(document).ready(function() {
//     $(document).bind("contextmenu", function(e) {
//         return false; // Prevents the default context menu from appearing
//     });
// });

// ==============================================================
// 页面加载完成后初始化所有功能
// ==============================================================
$(document).ready(function($) {
  // 初始化购物车按钮功能
  initAddToCart();
});



// 购物页更新Linked Optin和已选的size
/*
$(document).ready(function() {
    // 仅在存在目标元素时执行
    if ($('.lv-option-wrapper').length === 0) return;

    // 短延迟确保DOM完全就绪
    setTimeout(function() {
        // 解析URL参数
        const urlParams = new URLSearchParams(window.location.search);

        // 选项组处理逻辑
        const processOptionGroups = function() {
            // 存储所有有效选项组
            const optionGroups = [];

            // 遍历所有产品选项字段集
            $('.hdt-product-form__input').each(function() {
                const $fieldset = $(this);
                const $legend = $fieldset.find('.hdt-product-form__label').first();
                if (!$legend.length) return;

                // 提取选项组名称（用于URL参数）
                const legendText = $legend.text().trim();
                const groupName = legendText.split(':')[0].trim()
                    .toLowerCase()
                    .replace(/\s+/g, '_');
                if (!groupName) return;

                // 处理Radio类型选项组（如Apple Watch尺寸）
                const $radioInputs = $fieldset.find('input[type="radio"]');
                if ($radioInputs.length > 0) {
                    const $labels = $radioInputs.map(function() {
                        const radioId = $(this).attr('id');
                        return $fieldset.find(`label[for="${radioId}"]`).get(0);
                    }).filter(function() { return this !== null; });

                    if ($labels.length) {
                        optionGroups.push({
                            type: 'radio',
                            name: groupName,
                            $inputs: $radioInputs,
                            $options: $(($labels)),
                            getValue: function() {
                                return this.$inputs.filter(':checked').val() || '';
                            },
                            findOption: function(targetValue) {
                                const $matchingRadio = this.$inputs.filter(function() {
                                    return $(this).val().toLowerCase() === targetValue.toLowerCase();
                                }).first();
                                if ($matchingRadio.length) {
                                    return $fieldset.find(`label[for="${$matchingRadio.attr('id')}"]`);
                                }
                                return null;
                            }
                        });
                    }
                    return; // 处理完Radio组则跳过Button组检查
                }

                // 处理Button类型选项组（如手机型号）
                const $buttonContainer = $fieldset.find('hdt-richlist');
                if ($buttonContainer.length) {
                    const $buttons = $buttonContainer.find('button[role="option"]');
                    if ($buttons.length) {
                        optionGroups.push({
                            type: 'button',
                            name: groupName,
                            $options: $buttons,
                            getValue: function() {
                                return this.$options.filter('[aria-selected="true"]').val() || '';
                            },
                            findOption: function(targetValue) {
                                return this.$options.filter(function() {
                                    return $(this).val().toLowerCase() === targetValue.toLowerCase();
                                }).first();
                            }
                        });
                    }
                }
            });

            return optionGroups;
        };

        // 获取所有选项组
        const optionGroups = processOptionGroups();
        if (optionGroups.length === 0) return;

        // 更新链接参数
        function updateLinks() {
            const params = {};
            optionGroups.forEach(group => {
                const value = group.getValue();
                if (value) params[group.name] = value;
            });

            $('.lv-option-wrapper a.lv-option-item-link').each(function() {
                const $link = $(this);
                const href = $link.attr('href') || '';
                const [base, query] = href.split('?');
                const linkParams = new URLSearchParams(query || '');

                // 更新所有参数
                Object.keys(params).forEach(key => {
                    linkParams.set(key, params[key]);
                });

                const newHref = base + (linkParams.toString() ? `?${linkParams.toString()}` : '');
                $link.attr('href', newHref);
            });
        }

        // 模拟真实点击
        function triggerClick($el) {
            if (!$el || !$el.length) return false;
            
            // 创建并触发原生点击事件
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            $el[0].dispatchEvent(clickEvent);
            return true;
        }

        // 初始化URL参数匹配
        function initFromUrl() {
            optionGroups.forEach(group => {
                const paramValue = urlParams.get(group.name);
                if (!paramValue) return;

                const $targetOption = group.findOption(paramValue);
                if ($targetOption && $targetOption.length) {
                    // 只有当前值不匹配时才触发点击
                    if (group.getValue().toLowerCase() !== paramValue.toLowerCase()) {
                        triggerClick($targetOption);
                    }
                }
            });

            // 初始化后更新链接
            setTimeout(updateLinks, 300);
        }

        // 绑定点击事件
        function bindEvents() {
            optionGroups.forEach(group => {
                group.$options.on('click', function() {
                    // 延迟确保原生逻辑执行完毕
                    setTimeout(updateLinks, 150);
                });
            });
        }

        // 执行初始化
        bindEvents();
        initFromUrl();

    }, 600); // 延迟500ms确保页面脚本加载完成
});
*/
